import { defineAsyncComponent } from 'vue'
export default {
  strapi: defineAsyncComponent(() => import("/app/apps/alphabet/layouts/strapi.vue").then(m => m.default || m))
}